import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  type: 'initial' | 'final';
}
export function Testimonials({
  type
}: TestimonialProps) {
  const initialTestimonials = [{
    initials: 'LP',
    quote: 'Entendí por qué siempre atraía el mismo tipo de hombre con distinto nombre. Esto me cambió la cabeza y la forma de relacionarme.',
    author: 'Lucía P.',
    location: 'Buenos Aires | 32 años'
  }, {
    initials: 'CM',
    quote: 'Yo creía que amaba demasiado. En realidad estaba disponible para cualquiera. El Tomo 7 me dio el quiebre que necesitaba.',
    author: 'Carla M.',
    location: 'Córdoba | 29 años'
  }, {
    initials: 'NR',
    quote: 'Me sentía invisible con todos los hombres que me gustaban. Ahora entiendo mi energía, mi Venus y por qué repetía el patrón.',
    author: 'Natalia R.',
    location: 'Rosario | 36 años'
  }];
  const finalTestimonials = [{
    initials: 'LP',
    author: 'Lucía P.',
    location: 'Buenos Aires 🇦🇷',
    quote: 'Compré un viernes a la noche. El sábado a la tarde ya tenía claro por qué siempre atraía lo mismo. Nunca más voy a elegir desde la herida.'
  }, {
    initials: 'CM',
    author: 'Carla M.',
    location: 'Córdoba 🇦🇷',
    quote: 'El Bonus del contacto cero me salvó. Dejé de mirar su perfil 20 veces por día y por primera vez empecé a volver a mí misma.'
  }, {
    initials: 'NR',
    author: 'Natalia R.',
    location: 'Rosario 🇦🇷',
    quote: 'Lo de Venus y Lilith me voló la cabeza. Entendí por qué siempre me sentía invisible con hombres emocionalmente cerrados.'
  }, {
    initials: 'SV',
    author: 'Sofía V.',
    location: 'Mendoza 🇦🇷',
    quote: 'El Élite 1 fue el quiebre real. Dejé de estar disponible para cualquiera y cambió completamente cómo me perciben los hombres.'
  }, {
    initials: 'DA',
    author: 'Daniela A.',
    location: 'Santa Fe 🇦🇷',
    quote: 'Leí mil cosas sobre autoestima y amor propio. Esto fue lo primero que me bajó el problema a tierra y me dio pasos concretos para actuar distinto.'
  }, {
    initials: 'CR',
    author: 'Camila R.',
    location: 'Tucumán 🇦🇷',
    quote: 'No es solo astrología. Es una radiografía emocional completa. Eso fue lo que hizo que dejara de repetir la misma historia con hombres diferentes.'
  }];
  const data = type === 'initial' ? initialTestimonials : finalTestimonials;
  return <section className={`py-16 px-4 ${type === 'final' ? 'bg-mystic-900' : 'bg-mystic-800/30'}`} data-id="element-260">
      <div className="max-w-6xl mx-auto" data-id="element-261">
        {type === 'final' && <div className="text-center mb-12" data-id="element-262">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-263">
              Lo que dicen otras mujeres
            </h2>
            <div className="flex items-center justify-center gap-2 text-gold-400 text-xl font-medium" data-id="element-264">
              <span data-id="element-265">4.9/5</span>
              <div className="flex" data-id="element-266">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-267" />)}
              </div>
            </div>
          </div>}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-268">
          {data.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-mystic-800/50 border border-mystic-700 rounded-2xl p-6 relative overflow-hidden" data-id="element-269">
              <div className="absolute top-0 right-0 w-24 h-24 bg-lilac-500/5 rounded-bl-full" data-id="element-270" />
              <div className="flex items-center gap-4 mb-4" data-id="element-271">
                <div className="w-12 h-12 rounded-full bg-mystic-700 flex items-center justify-center text-gold-400 font-serif font-bold text-lg border border-mystic-600" data-id="element-272">
                  {t.initials}
                </div>
                <div data-id="element-273">
                  <div className="font-bold text-white" data-id="element-274">{t.author}</div>
                  <div className="text-sm text-lilac-300" data-id="element-275">{t.location}</div>
                </div>
              </div>
              <div className="flex gap-0.5 text-gold-400 mb-4" data-id="element-276">
                {[...Array(5)].map((_, s) => <Star key={s} className="w-4 h-4 fill-current" data-id="element-277" />)}
              </div>
              <p className="text-slate-300 italic leading-relaxed" data-id="element-278">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}